import React, { useRef, useState } from 'react';
import { FaUtensils, FaUmbrellaBeach, FaBath, FaBed, FaTv, FaHome, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const amenitiesData = [
  {
    category: 'Cozinha e Jantar',
    icon: <FaUtensils />,
    items: [
      { label: 'Espaço', value: 'Cozinha e Mesa de Jantar.' },
      { label: 'Eletrodomésticos', value: 'Geladeira, Fogão, Forno, Microondas, Airfryer, Liquidificador, Sanduicheira.' },
      { label: 'Utensílios', value: 'Itens básicos de cozinha, Louças e talheres, Taças de vinho.' }
    ]
  },
  {
    category: 'Área Gourmet e Lazer Externo',
    icon: <FaUmbrellaBeach />,
    items: [
      { label: 'Churrasco', value: 'Churrasqueira e Utensílios para churrasco.' },
      { label: 'Fogo', value: 'Fogueira (área externa).' }
    ]
  },
  {
    category: 'Bem-estar e Banheiro',
    icon: <FaBath />,
    items: [
      { label: 'Relaxamento', value: 'Jacuzzi privativa / Banheira jacuzzi.' },
      { label: 'Higiene', value: 'Água quente e Secador de cabelo.' }
    ]
  },
  {
    category: 'Quarto e Conforto',
    icon: <FaBed />,
    items: [
      { label: 'Dormitório', value: 'Cobertores e travesseiros extras, Local para guardar as roupas, Blackout nas cortinas.' },
      { label: 'Climatização', value: 'Lareira interna.' }
    ]
  },
  {
    category: 'Entretenimento e Conectividade',
    icon: <FaTv />,
    items: [
      { label: 'Tecnologia', value: 'Wifi, TV, Sistema de som.' }
    ]
  },
  {
    category: 'Utilidades e Estrutura',
    icon: <FaHome />,
    items: [
      { label: 'Cuidados', value: 'Varal para secar roupa.' },
      { label: 'Acessibilidade', value: 'Casa Térrea.' },
      { label: 'Infantil', value: 'Cadeira alta.' }
    ]
  }
];

const Amenities = () => {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToBooking = () => {
    const bookingSection = document.querySelector('.booking-widget');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToIndex = (index) => {
    if (scrollRef.current) {
      const card = scrollRef.current.querySelector('.amenity-category');
      if (card) {
        const gap = 20; // Gap definido no CSS mobile
        const itemWidth = card.clientWidth + gap;
        scrollRef.current.scrollTo({
          left: index * itemWidth,
          behavior: 'smooth'
        });
        setActiveIndex(index);
      }
    }
  };

  const handleNext = () => {
    let nextIndex = activeIndex + 1;
    if (nextIndex >= amenitiesData.length) {
      nextIndex = 0; // Loop para o início
    }
    scrollToIndex(nextIndex);
  };

  const handlePrev = () => {
    let prevIndex = activeIndex - 1;
    if (prevIndex < 0) {
      prevIndex = amenitiesData.length - 1; // Loop para o final
    }
    scrollToIndex(prevIndex);
  };

  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollLeft = scrollRef.current.scrollLeft;
      const card = scrollRef.current.querySelector('.amenity-category');
      if (card) {
        const gap = 20;
        const itemWidth = card.clientWidth + gap;
        const newIndex = Math.round(scrollLeft / itemWidth);
        if (newIndex !== activeIndex && newIndex >= 0 && newIndex < amenitiesData.length) {
          setActiveIndex(newIndex);
        }
      }
    }
  };

  return (
    <section className="amenities-section" id="amenities">
      <h2>Comodidades</h2>
      
      <div className="amenities-carousel-wrapper">
        <button className="nav-arrow left" onClick={handlePrev}><FaChevronLeft /></button>
        <div className="amenities-grid" ref={scrollRef} onScroll={handleScroll}>
          <div className="amenities-track">
          {amenitiesData.map((category, index) => (
            <div className="amenity-category" key={index}>
              <div className="category-header">
                <span className="category-icon">{category.icon}</span>
                <h3>{category.category}</h3>
              </div>
              <ul className="amenity-list">
                {category.items.map((item, idx) => (
                  <li key={idx}>
                    <strong>{item.label}:</strong> {item.value}
                  </li>
                ))}
              </ul>
            </div>
          ))}
          </div>
        </div>
        <button className="nav-arrow right" onClick={handleNext}><FaChevronRight /></button>
      </div>

      {/* Controles Mobile */}
      <div className="amenities-controls">
        <div className="amenities-dots">
          {amenitiesData.map((_, idx) => (
            <span key={idx} className={`dot ${idx === activeIndex ? 'active' : ''}`} onClick={() => scrollToIndex(idx)}></span>
          ))}
        </div>
      </div>

      <div className="amenities-cta-container">
        <button className="section-cta" onClick={scrollToBooking}>
          Reservar
        </button>
      </div>
    </section>
  );
};

export default Amenities;
